import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {ChevronLeft, ChevronLeftSmall, DismissSmall, X} from '@wix/wix-ui-icons-common'
import {useExperiments, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import s from './popup-header.scss'

interface PopupHeaderProps {
  text: string
  eventList?: boolean
  eventDetails?: boolean
  onClose: () => void
  onBack?: () => void
}

export const PopupHeader = ({text, eventList, eventDetails, onBack, onClose}: PopupHeaderProps) => {
  const {t} = useTranslation()
  const {experiments} = useExperiments()
  const calendarRevampEnabled = experiments.enabled(ExperimentNames.CalendarRevamp)

  const handleBackKeyPress = event => {
    if (event.key === 'Enter') {
      onBack?.()
    }
  }

  const handleCloseKeyPress = event => {
    if (event.key === 'Enter') {
      onClose()
    }
  }

  const backClickHandler = onBack || (() => {})

  return calendarRevampEnabled && eventDetails ? (
    <div className={s.headerContainer}>
      {!!onBack && (
        <div
          data-hook="calendar-popup-back-button"
          className={s.headerButton}
          tabIndex={0}
          onClick={backClickHandler}
          onKeyPress={handleBackKeyPress}
        >
          <ChevronLeftSmall />
        </div>
      )}
      <div
        data-hook="calendar-popup-close-button"
        className={classNames(s.headerButton, s.close)}
        tabIndex={0}
        role="button"
        aria-label={t('a11y.close')}
        onClick={onClose}
        onKeyPress={handleCloseKeyPress}
      >
        <DismissSmall />
      </div>
    </div>
  ) : (
    <div>
      <div
        className={classNames(s.date, {
          [s.dateWithChevron]: onBack,
          [s.eventList]: eventList,
          [s.eventDetails]: eventDetails,
        })}
      >
        {!!onBack && (
          <div
            data-hook="calendar-popup-back-button"
            className={s.dateChevron}
            tabIndex={0}
            onClick={backClickHandler}
            onKeyPress={handleBackKeyPress}
          >
            <ChevronLeft size="24px" />
          </div>
        )}
        <div
          data-hook="calendar-popup-title"
          className={s.dateText}
          onClick={backClickHandler}
          onKeyPress={handleBackKeyPress}
        >
          {text}
        </div>
      </div>
      <div
        data-hook="calendar-popup-close-button"
        className={s.close}
        tabIndex={0}
        role="button"
        aria-label={t('a11y.close')}
        onClick={onClose}
        onKeyPress={handleCloseKeyPress}
      >
        <X size="16px" />
      </div>
    </div>
  )
}
